import { useMutation } from '@connectrpc/connect-query'
import { approveBiddingBlockApprovalRequests } from '@ebalance/proto/bffuser/v1/bidding_block_service-BiddingBlockService_connectquery'

import { useWorkflowCaseScopedMutation } from '~/hooks/bidding/useWorkflowCaseScopedMutation'
import type { InvalidatingMutationResultFor } from '~/hooks/useInvalidatingMutation'

/**
 * ブロック入札のまとめて承認 mutation hook (AC-BSP-118)。 通常入札の
 * `useApproveBiddingSpotApprovalRequests` と同じ理由で invalidate を持たない。
 */
export const useApproveBiddingBlockApprovalRequests =
  (): InvalidatingMutationResultFor<
    typeof approveBiddingBlockApprovalRequests
  > =>
    useWorkflowCaseScopedMutation(
      useMutation(approveBiddingBlockApprovalRequests),
    )
